<script lang="ts">
  import { INSIGHTS_FINDINGS_GRANT, PULSE_GRANT } from "@colossus/contracts";
  import { modulePath } from "@colossus/contracts/module";
  import { m } from "#messages";
  import { DEMO_TENANT } from "#lib/demo/replay.ts";
  import EntranceFooter from "#lib/entrance/EntranceFooter.svelte";
  import EntranceHeader from "#lib/entrance/EntranceHeader.svelte";
  import { planBadge } from "#lib/products/plan-badge.ts";
  import ProductHero from "#lib/products/ProductHero.svelte";
  import ProductSections from "#lib/products/ProductSections.svelte";
  import type { ProductSection } from "#lib/products/ProductSections.svelte";
  import Meta from "#lib/seo/Meta.svelte";
  import CtaBand from "#lib/site/CtaBand.svelte";
  import DemoShowroom from "#lib/site/DemoShowroom.svelte";
  import type { PageProps } from "./$types.ts";

  let { data }: PageProps = $props();

  const SECTIONS: readonly ProductSection[] = $derived([
    {
      id: "insights",
      title: null,
      lede: null,
      tiles: [
        {
          preview: "pulse",
          title: m.features_pulse(),
          body: m.features_pulse_body(),
          plan: planBadge(PULSE_GRANT),
        },
        {
          preview: "findings",
          title: m.landing_findings_title(),
          body: m.features_findings_body(),
          plan: planBadge(INSIGHTS_FINDINGS_GRANT),
        },
        {
          preview: "impact",
          title: m.products_row_impact_title(),
          body: m.products_row_impact_body(),
          plan: planBadge(PULSE_GRANT),
        },
      ],
    },
  ]);
</script>

<Meta title={m.meta_intelligence_title()} description={m.meta_intelligence_description()} />

<EntranceHeader me={data.me} />

<main class="overflow-x-clip">
  <ProductHero
    headline={m.products_intelligence_headline()}
    lede={m.products_intelligence_lede()}
    testId="intelligence-hero"
  >
    {#snippet picture()}
      <DemoShowroom
        href={modulePath(DEMO_TENANT, "intelligence")}
        testId="intelligence-live"
        hero="overview"
      />
    {/snippet}
  </ProductHero>

  <ProductSections sections={SECTIONS} testId="intelligence" />

  <CtaBand title={m.products_closing_title()} body={m.products_closing_body()} />
</main>

<EntranceFooter />
